import React from 'react';
import RouteConstants from '../../constants/routeConstants';
import CustomTabs from '../../sharedcomponents/customTabs/customTabs';
import { useState, Downgraded } from '@hookstate/core';
import { Box } from '@mui/material';
import CustomizedSnackbars from '../../sharedcomponents/snackbar/snackBar';
import ActivityList from './activityList';
import Helper from '../../utility/helper';
import Title from '../../sharedcomponents/title/title';

const Schedule = () =>
{

    const tabValue = useState(0);
    const eventInfo = Helper.getStorage('eventInfo');
    const userInfo = Helper.getStorage('userInfo');
    let collectionTabs = [];
    if (Helper.isAdminUser(userInfo) || Helper.isEventAdmin(userInfo))
    {
        collectionTabs = useState([
            {
                label: 'Activity',
                value: 0,
                component: ActivityList,
                data: [],
            },
            {
                label: 'User Activity',
                value: 1,
                component: ActivityList,
                data: [{ tab: 'userActivity' }],
            },
        ]);
    }else if(Helper.isEventStaff(userInfo)){
        collectionTabs = useState([ 
            {
                label: 'User Activity',
                value: 1,
                component: ActivityList,
                data: [{ tab: 'userActivity' }],
            },
        ]);
    }
    else if (eventInfo.isStaffScheduled)
    {
        collectionTabs = useState([
            {
                label: 'Activity',
                value: 0,
                component: ActivityList,
                data: [],
            },
            {
                label: 'User Activity',
                value: 1,
                component: ActivityList,
                data: [{ tab: 'userActivity' }],
            },
        ]);
    } else
    {
        collectionTabs = useState([
            {
                label: 'Activity',
                value: 0,
                component: ActivityList,
                data: [],
            }
        ]);
    }


    const [snackBarProps, setSnackBarProps] = React.useState({
        openSnack: false,
        variant: 'error',
        message: '',
    });

    const handleChange = (value) =>
    {
        tabValue.set(value);
    };
    return (
        <Box
            sx={{
                // p: 2,
                width: '100%',
            }}>
            <Box className='contentBox'>
                {(Helper.isAdminUser(userInfo) || (userInfo.roles && Helper.isEventAdmin(userInfo))) ?
                    <Title
                        title={'Participant Schedule'}
                        sx={{
                            ml: 0,
                        }}
                        px={0}
                    /> : null}
                <CustomTabs
                    snackBarProps={snackBarProps}
                    setSnackBarProps={setSnackBarProps}
                    value={tabValue.get()}
                    handleChange={handleChange}
                    data={collectionTabs.attach(Downgraded).get()}
                    removeMargin={true}
                />
            </Box>
            {snackBarProps.openSnack && (
                <CustomizedSnackbars
                    {...snackBarProps}
                    onClose={() =>
                        setSnackBarProps({ ...snackBarProps, openSnack: false })
                    }></CustomizedSnackbars>
            )}
        </Box>
    )

}

export default {
    routeProps: {
        path: RouteConstants.EVENT_SCHEDULE,
        component: Schedule,
    },
    name: 'Schedule',
};
